import { render } from "./TableItem.vue?vue&type=template&id=74ca29f7&scoped=true"
import script from "./TableItem.vue?vue&type=script&lang=ts"
export * from "./TableItem.vue?vue&type=script&lang=ts"

import "./TableItem.vue?vue&type=style&index=0&id=74ca29f7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74ca29f7"

export default script